import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { WidgetToolbarRepository } from '@ckeditor/ckeditor5-widget';
import { isObject } from 'lodash-es';

export default class ImgToolbarEditing extends Plugin {
  
	static get requires() {
		return [ WidgetToolbarRepository ];
	}

	
	afterInit() {
		const editor = this.editor;
		const t = editor.t;
		const widgetToolbarRepository = editor.plugins.get( WidgetToolbarRepository );

		widgetToolbarRepository.register( 'image', {
			ariaLabel: t( 'Image toolbar' ),
			items: this.normalizeDeclarativeConfig([
				'ToggleCaption'
			  ] ),
			balloonClassName: 'imageToolbar' ,
			getRelatedElement:selection => this.getRelatedElementFunction(selection)
		} );
	}

	normalizeDeclarativeConfig( config ) {
		return config.map( item => isObject( item ) ? item.name : item );
	}

	getRelatedElementFunction(selection){
		const selectionPosition = selection.getFirstPosition();

		if ( !selectionPosition ) {
			return null;
		}

		const viewElement = selection.getSelectedElement();
		
		if (viewElement?.name ==='figure' && viewElement?._children[0]?._children[0]?.name==='img') {
			return viewElement;
		}
		return null;
	}

}
